import { configWithTokenId } from './constructor-api'
import store from '../store'

const getUserCouponHistory = async (lang) => {
  return await configWithTokenId(async (API) => {
    const branchUUID = store.getters['branch/branchUUID']
    if(branchUUID != null && branchUUID != 'null')
      return await API.get(`/point/history/member?branchUUID=${branchUUID}`);
    throw 'Not Empty Data'
  })
}

export {
  getUserCouponHistory,
}